/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Not_FoundInputs */

const en_control_not_found = /** @type {(inputs: Control_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This route has slipped out of reach. Choose a tool or guide to continue.`)
};

const zh_control_not_found = /** @type {(inputs: Control_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到此页面，请选择工具或攻略继续浏览。`)
};

/**
* | output |
* | --- |
* | "This route has slipped out of reach. Choose a tool or guide to continue." |
*
* @param {Control_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_not_found = /** @type {((inputs?: Control_Not_FoundInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Not_FoundInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_not_found(inputs)
	return zh_control_not_found(inputs)
});
export { control_not_found as "control.not_found" }